import { render, staticRenderFns } from "./SortItem.vue?vue&type=template&id=41572562&"
import script from "./SortItem.vue?vue&type=script&lang=ts&"
export * from "./SortItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports